<template>
  <v-card
    v-set-test-id="
      $attrs.loading
        ? undefined
        : ['BaseCard', testId || $attrs.to || $attrs.href]
    "
    v-bind="$attrs"
    class="flex-grow-1 d-flex flex-column justify-center"
    :class="$attrs.class"
  >
    <template #loader="{ isActive }">
      <base-linear-loader :is-visible="isActive" />
    </template>
    <slot name="title-section">
      <v-card-title v-if="slots.title || title" class="text-primary">
        <slot name="title" v-bind="{ title }">
          {{ title }}
        </slot>
      </v-card-title>
      <v-card-subtitle v-if="slots.subTitle || subTitle">
        <slot name="subTitle">
          {{ subTitle }}
        </slot>
      </v-card-subtitle>
    </slot>
    <slot name="content-section">
      <v-card-text
        v-if="slots.default"
        class="flex-grow-1 flex-column justify-center"
        :class="contentClass"
      >
        <slot name="default" />
      </v-card-text>
    </slot>
    <v-divider v-if="slots.actions" />
    <v-card-actions v-if="slots.actions" :class="actionsClass">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';
import { useSlots } from 'vue';

type Props = ActionableComponentProps & {
  title?: string;
  subTitle?: string;
  contentClass?: string;
  actionsClass?: string | Record<string, boolean> | string[];
};
withDefaults(defineProps<Props>(), { actionsClass: 'justify-end' });

const slots = useSlots();
</script>

<style lang="scss">
@use 'sass:map';
@use 'vuetify/lib/styles/settings/_variables' as *;

$card-text-padding: $spacer * 4;
$card-actions-padding: $spacer * 2;

.v-card__text {
  @media #{map.get($display-breakpoints, 'xs')} {
    padding: $card-text-padding;
    & > .v-data-table,
    & > .v-divider {
      margin-left: -$card-text-padding;
      margin-right: -$card-text-padding;
    }
  }
  @media #{map.get($display-breakpoints, 'sm')} {
    padding: $card-text-padding;
    & > .v-data-table,
    & > .v-divider {
      margin-left: -$card-text-padding;
      margin-right: -$card-text-padding;
    }
  }
  @media #{map.get($display-breakpoints, 'md')} {
    padding: $card-text-padding;
    & > .v-data-table,
    & > .v-divider {
      margin-left: -$card-text-padding;
      margin-right: -$card-text-padding;
    }
  }
  @media #{map.get($display-breakpoints, 'lg-and-up')} {
    padding: $card-text-padding;
    & > .v-data-table,
    & > .v-divider {
      margin-left: -$card-text-padding;
      margin-right: -$card-text-padding;
    }
  }
}
.v-card__text {
  padding: $card-text-padding;
  & > .v-data-table,
  & > .v-divider {
    margin-left: -$card-text-padding;
    margin-right: -$card-text-padding;
  }
}

.v-card__text {
  & > .v-data-table,
  & > .v-divider {
    max-width: inherit;
  }
}
.v-card__actions > * {
  margin-bottom: $card-actions-padding;
}
.v-card__title {
  word-break: break-word;
}
</style>
